import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { getCartState, getUiState } from "../../../store";
import CartFooterIcon from "../../../assets/icons/CartFooterIcon";
import { useMemo, useState } from "react";
import PlusIcon from "../../../assets/icons/PlusIcon";
import MinusIcon from "../../../assets/icons/MinusIcon";
import {
  addProductToCart,
  clearCart,
  removeProductInCart,
  updateQuantityProductInCart,
} from "../../../store/slices/cartSlice";
import {
  disableScrollScreen,
  enableScrollScreen,
  showCartModal,
} from "../../../store/slices/uiSlice";
import CartIcon from "../../../assets/icons/CartIcon";
import { getCartItemUnitPrice } from "../../../helpers/handleProduct";

export default function FooterCart() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { cartInfo } = useAppSelector(getCartState);
  const { isShowCart } = useAppSelector(getUiState);
  const [quantity, setQuantity] = useState<number>();
  const [itemEditQuantity, setItemEditQuantity] = useState<number>();
  const [isEditQuantity, setIsEditQuantity] = useState<boolean>(false);
  const totalPrice = useMemo(() => {
    return cartInfo.reduce(
      (accumulator, currentValue) => {
        const unitPrice = getCartItemUnitPrice(currentValue);
        return accumulator + unitPrice * currentValue.quantity;
      },
      0
    );
  }, [cartInfo]);
  const baseTotalPrice = useMemo(() => {
    return cartInfo.reduce(
      (accumulator, currentValue) =>
        accumulator + currentValue.price_sale * currentValue.quantity,
      0
    );
  }, [cartInfo]);
  const showBaseTotal = baseTotalPrice > totalPrice;
  return (
    <div className="hidden max-md:block max-md:relative">
      {cartInfo.length > 0 && (
        <div
          className="flex justify-between items-center gap-2 bg-white p-4 fixed bottom-0 inset-x-0 z-10"
          style={{ boxShadow: "4px 0px 4px rgb(0 0 0 / 25%)" }}
        >
          {!isShowCart && (
            <button className="flex items-center gap-2">
              <div
                className="relative"
                onClick={() => {
                  dispatch(showCartModal());
                  dispatch(disableScrollScreen());
                }}
              >
                <CartFooterIcon />
                <span className="bg-red-500 rounded-[50%] px-2 absolute -top-2 -right-4 text-white text-sm">
                  {" "}
                  {cartInfo.length}
                </span>
              </div>
              <div className="flex items-center gap-2 pl-3 pt-1">
                <p className="text-xl font-medium">{totalPrice.toLocaleString("vi-VN")}</p>
                {showBaseTotal && (
                  <p className="text-xs text-[#7A8086] line-through">{baseTotalPrice.toLocaleString("vi-VN")}</p>
                )}
              </div>
            </button>
          )}
          <button
            className={
              isShowCart
                ? "bg-[#0088FF] text-white flex item-center justify-center gap-1 px-4 py-2 rounded text-xl w-full"
                : "bg-[#0088FF] text-white flex item-center justify-center gap-1 px-4 py-2 rounded text-xl"
            }
            onClick={() => {
              if (isShowCart) {
                dispatch(showCartModal());
                dispatch(enableScrollScreen());
                navigate("/checkout");
                return;
              }
              navigate("/checkout");
            }}
          >
            {isShowCart && <CartIcon />}
            Đặt đơn
          </button>
        </div>
      )}
      {cartInfo.length > 0 && isShowCart && (
        <div className="hidden max-md:flex max-md:flex-col max-md:h-screen max-md:fixed max-md:inset-x-0 max-md:bottom-[72px] z-10">
          <div
            className="bg-black flex-1 opacity-50"
            onClick={() => {
              dispatch(showCartModal());
              dispatch(enableScrollScreen());
            }}
          ></div>
          <div
            className=" flex flex-col gap-2 bg-white px-4 py-3"
            style={{ boxShadow: "0 -1px 7px 1px #888888" }}
          >
            <div className="flex justify-between items-center py-4 bg-white rounded border-b-[1px] border-[#F3F4F5] border-solid">
              <h3 className="font-medium text-lg text-[#182537]">
                Đã chọn ({cartInfo.length})
              </h3>
              {cartInfo.length > 0 && (
                <button
                  className="text-xs text-[#FF4D4D] cursor-pointer hover:bg-[#F4F4F4] p-1"
                  onClick={() => {
                    dispatch(clearCart());
                    dispatch(showCartModal());
                    dispatch(enableScrollScreen());
                  }}
                >
                  Xóa giỏ hàng
                </button>
              )}
            </div>
            <div className="max-h-[calc(100vh-350px)] overflow-y-auto py-2 flex flex-col gap-2">
              {!!cartInfo.length &&
                cartInfo.map((item, index) => {
                  const unitPrice = getCartItemUnitPrice(item);
                  const linePrice = unitPrice * item.quantity;
                  const baseLinePrice = item.price_sale * item.quantity;
                  const showLineDiscount = unitPrice < item.price_sale;
                  return (
                    <div
                      key={index}
                      className="flex flex-col gap-2 py-2 w-full "
                    >
                      <h1 className="text-sm font-medium">{item.name}</h1>
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-1">
                          <button
                            onClick={() => {
                              dispatch(removeProductInCart(item.id));
                              setIsEditQuantity((prev) => (prev = false));
                            }}
                          >
                            <MinusIcon />
                          </button>
                          {itemEditQuantity === item.id &&
                            isEditQuantity ? (
                            <input
                              type="text"
                              value={quantity}
                              onBlur={() => {
                                if (!quantity) {
                                  dispatch(removeProductInCart(item.id));
                                  return;
                                }
                                dispatch(
                                  updateQuantityProductInCart({
                                    id: item.id,
                                    quantity: quantity,
                                  })
                                );
                              }}
                              onChange={(ev) =>
                                setQuantity((prev) => (prev = +ev.target.value))
                              }
                              className="outline-none w-14 flex-1 text-center border-b-2 border-b-[#F4F1F1] border-solid"
                            />
                          ) : (
                            <input
                              type="text"
                              value={item.quantity}
                              onClick={() => {
                                setItemEditQuantity(
                                  (prev) => (prev = item.id)
                                );
                                setQuantity((prev) => (prev = item.quantity));
                                setIsEditQuantity((prev) => (prev = true));
                              }}
                              className="outline-none w-14 flex-1 text-center border-b-2 border-b-[#F4F1F1] border-solid"
                            />
                          )}

                          <button
                            onClick={() => {
                              dispatch(addProductToCart(item));
                              setIsEditQuantity((prev) => (prev = false));
                            }}
                          >
                            <PlusIcon />
                          </button>
                        </div>
                        <div className="flex items-center gap-2">
                          <p className="text-sm text-[#182537]">
                            {linePrice.toLocaleString("vi-VN")}
                          </p>
                          {showLineDiscount && (
                            <p className="text-xs text-[#7A8086] line-through">
                              {baseLinePrice.toLocaleString("vi-VN")}
                            </p>
                          )}
                        </div>
                      </div>
                      {/* <input type="text" placeholder="Thêm ghi chú" className="outline-none pb-1 pl-1 w-full focus:border-b-2 focus:border-b-[#F4F1F1] placeholder:text-xs placeholder:italic" /> */}
                    </div>
                  );
                })}
            </div>

            <div className="flex justify-between items-center">
              <h1 className="text-base font-normal text-[#182537]">
                Tổng tiền
              </h1>
              <div className="flex items-center gap-2">
                <p className="text-base font-bold text-[#182537]">
                  {totalPrice.toLocaleString("vi-VN")}
                </p>
                {showBaseTotal && (
                  <p className="text-xs text-[#7A8086] line-through">
                    {baseTotalPrice.toLocaleString("vi-VN")}
                  </p>
                )}
              </div>
            </div>
            <div></div>
          </div>
        </div>
      )}
    </div>
  );
}
